import { Breadcrumbs, Hidden, Typography, withStyles } from '@material-ui/core';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { privateRoutes, getBreadcrumbComplementName } from '../../extranetRoutes';
import { throwErrorMessage } from '../../lib/error_helper';

const styles = {
    typography: {
        maxHeight: "100%",
        overflowY: "hidden",
        fontSize: 18,
        paddingLeft: "5px",
        color: "#F5F6F5",
        paddingRight: "2px",
        "&:hover": {
            color: "#F5F6F5",
        }
    },
    currentTypography: {
        fontFamily: "EDF2020_Bold",
    },
    subTitle: {
        fontFamily: "EDF2020_Italic",
    },
    separator: {
        color: "#F5F6F5"
    }
};

class ExtranetBreadcrumbs extends Component {

    render() {
        const { classes } = this.props;
        const pathnames = this.props.location.pathname.split('/').filter(x => x);

        return (
            <>
                <Hidden only={['sm', 'xs']}>
                    <Breadcrumbs aria-label="breadcrumb" classes={{
                        separator: classes.separator
                    }}>
                        {pathnames.map((value, index) => {
                            const last = index === pathnames.length - 1;
                            const to = `/${pathnames.slice(0, index + 1).join('/')}`;
                            const currentBreadcrumbPartName = privateRoutes.find(r => r.path === to);

                            if (!currentBreadcrumbPartName || (index === 0 && pathnames.length !== 1))
                                return null;

                            return last || (index === 0 && pathnames.length === 1) ? (
                                <div className="row" key={index}>
                                    <Typography variant="body1" className={classes.currentTypography + " " + classes.typography}>
                                        {currentBreadcrumbPartName.title}
                                    </Typography>
                                    <Typography variant="body1" className={classes.subTitle + " " + classes.typography}>
                                        {" " + getBreadcrumbComplementName(value, this.props)}
                                    </Typography>
                                </div>
                            ) : (
                                <Link variant="body1" className={classes.typography + " row"} href="/" to={to} key={to}>
                                    <Typography variant="body1" className={classes.typography}>
                                        {currentBreadcrumbPartName.title}
                                    </Typography>
                                    <Typography variant="body1" className={classes.subTitle + " " + classes.typography}>
                                        {" " + getBreadcrumbComplementName(value, this.props)}
                                    </Typography>
                                </Link>
                            );
                        })}
                    </Breadcrumbs>
                </Hidden>
                <Hidden only={['xl', 'lg', 'md']}>
                    <Typography variant="body1" className={classes.currentTypography + " " + classes.typography}>
                        {this.props.locationTitle}
                    </Typography>
                </Hidden>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        currentPark: state.componentsPark.currentPark,
        currentComponent: state.componentsPark.currentComponent,
        currentIntervention: state.extranetIntervention.currentIntervention,
		locationTitle: state.locationTitle,
        affair: state.affair.currentAffair,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        throwErrorMessage: (errorObject) => dispatch(throwErrorMessage(errorObject)),
    };
};

export default compose(withRouter, withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(ExtranetBreadcrumbs);